export enum RuleType {
  CUSTOM = "CUSTOM",
  CONSISTENCY = "CONSISTENCY",
  TABLE_TOTALS = "TABLE_TOTALS",
}

export interface Rule {
  id: string;
  type?: RuleType;
  title: string;
  version: number;
  script: string;
  tagIds?: string[];
  tableTotals?: TableTotalsSpec;
}

export interface CellRef {
  row: number;
  column: number;
  id?: string;
}

export interface TableTotalsSpec {
  tableId: string;
  addends: CellRef[];
  subtotal: CellRef;
}
